/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import InputField from "../../../shared-ui/input-field";
import WhyAskingPopup from "../../../shared-ui/popup/why-asking-popup";
import WhyAskingComponent from "../../../shared-ui/why-asking";
import {
  setUserResponse,
  getPreFillDataByContentKey,
} from "../../../../utils/userResponse";
import _ from "lodash";
// Infterface Single Word Component Props
interface SingleWordComponentProps {
  questionTitle: string;
  questionSubTitle?: string;
  inputType?: string;
  inputPlaceHolder: string;
  question_label: string;
  isError?: boolean;
  errorMsg: any;
  whyQuestionList: [];
  language?: any;
  handleChildContinue?: any;
  handleSuccessfulContinue: any;
  recoId: any;
  contentTypeId: any;
}

// InfterfaceSingle Word Component state
interface SingleWordComponentState {
  inputValue: any;
  isEmptyValue: boolean;
  errorMsg?: string;
  isPopupOpen: boolean;
  isError: boolean;
  updatedLanguage?: string;
}

/**
 * Used for any answer type is in a single line.
 *
 * @namespace SingleWordComponent
 */

class SingleWordComponent extends React.Component<
  SingleWordComponentProps,
  SingleWordComponentState
> {
  constructor(props: SingleWordComponentProps) {
    super(props);
    this.state = {
      inputValue: "",
      isEmptyValue: false,
      isPopupOpen: false,
      isError: false,
      errorMsg: "",
      updatedLanguage: "",
    };
  }

  componentDidMount = () => {
    this.props.handleChildContinue(this.handleError);
    this.setPreFillData();
  };

  componentDidUpdate = () => {
    if (this.props.language !== this.state.updatedLanguage) {
      this.setState({
        inputValue: "",
        isError: false,
        updatedLanguage: this.props.language,
      });
      this.setPreFillData();
    }
  };
  /**
   * This method is used for handle input change
   * @param {Object} evt
   *
   */
  handleInputChange = (evt: any) => {
    this.setState(
      {
        inputValue: evt.target.value,
        isError: false,
      }
      // () => {
      //   this.props.inputValue(evt);
      // }
    );
  };

  /**
   * This method is used for handleAsking Popup open
   *
   */
  handlePopup = () => {
    this.setState({
      isPopupOpen: true,
    });
  };

  /**
   * This method is used for handle Why Asking Popup close
   *
   */
  closePopup = () => {
    this.setState({
      isPopupOpen: false,
    });
  };

  handleError = () => {
    const { inputValue } = this.state;
    const { empty_error, num_max, num_min } = this.props.errorMsg;
    if (inputValue !== "") {
      if (inputValue > parseInt(num_min && num_min[0])) {
        this.setState(
          {
            isError: false,
            errorMsg: "",
          },
          () => {
            this.props.handleSuccessfulContinue();
            this.getSelectedData();
          }
        );
      } else if (inputValue <= parseInt(num_min && num_min[0])) {
        this.setState({
          isError: true,
          errorMsg: num_min && num_min[1],
        });
      }
      // else {
      //   this.setState({
      //     isError: true,
      //     errorMsg: num_max && num_max[1],
      //   });
      // }
    } else {
      this.setState({
        isError: true,
        errorMsg: empty_error,
      });
    }
  };

  /**
   * @Name - getSelectedData
   * @Desc - This is used to find user response from options list
   *          and send to store.
   */
  getSelectedData = () => {
    let responseData = {
      contentTypeId: this.props.contentTypeId,
      recoId: this.props.recoId,
      recoValues: this.state.inputValue,
      values: this.state.inputValue,
    };
    setUserResponse(responseData);
  };
  /**
   * Used to set data as per users input(existing- if any)
   */
  setPreFillData = () => {
    let recoValuesData: any = getPreFillDataByContentKey(
      this.props.contentTypeId
    );
    if (recoValuesData && !_.isEmpty(recoValuesData)) {
      this.setState({
        inputValue: recoValuesData.values,
        isError: false,
      });
    }
  };

  render() {
    const {
      questionTitle,
      questionSubTitle,
      inputType,
      inputPlaceHolder,
      whyQuestionList,
      question_label,
    } = this.props;
    const { inputValue, isError, errorMsg } = this.state;
    return (
      <div className="inner-wrapper information-wrapper">
        <WhyAskingPopup
          {...this.props}
          open={this.state.isPopupOpen}
          close={this.closePopup}
          list={whyQuestionList}
        />

        <div className="question-wrappper question-type-input">
          <div className="question-label">{questionTitle || ""}</div>
          <div className="question-sub-label">{questionSubTitle || ""}</div>
        </div>

        <div className="input-container">
          <InputField
            type={inputType || "text"}
            placeHolder={inputPlaceHolder || ""}
            className={
              // "custom-input"
              isError ? "custom-input error-input" : "custom-input"
            }
            handleInputChange={(e: any) => {
              this.handleInputChange(e);
            }}
            inputValue={inputValue || ""}
            errorMsg={errorMsg}
            isError={isError}
            inputLabel={question_label}
            autoFocusOnInput
            maxLength={3}
          />
        </div>

        {whyQuestionList && whyQuestionList.length > 0 ? (
          <WhyAskingComponent {...this.props} handlePopup={this.handlePopup} />
        ) : null}
      </div>
    );
  }
}

export default SingleWordComponent;
